import { useQuery } from '@tanstack/react-query';
import { createLoyaltyQuery } from '~/services/loyalty/lib';
import { QueryKeys } from '~/services/loyalty/constants';
import { useLoyaltyContext } from '..';
import type { AllowedOptions } from '../allowedQueryOptions';
import type { LoyaltyApiError, MemberRewardsResponse } from '~/lib/data-contract/loyalty';

export const useActiveMemberRewards = <TData = MemberRewardsResponse>(
    options?: AllowedOptions<MemberRewardsResponse, TData>,
) => {
    const { businessCentralId, translate, trackError } = useLoyaltyContext();

    return useQuery<MemberRewardsResponse, LoyaltyApiError, TData>({
        queryKey: [QueryKeys.ACTIVE_MEMBER_REWARDS],
        queryFn: createLoyaltyQuery('GetActiveMemberRewards', translate, trackError, {
            memberId: businessCentralId,
        }),
        enabled: false,
        retry: false,
        refetchOnWindowFocus: false,
        gcTime: 1000 * 30,
        ...options,
    });
};
